import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ArbolMenu } from 'src/app/asistente-en-linea/components/asistencia-menu-arbol/models/arbol-menu';
import { NodeType } from 'src/app/asistente-en-linea/components/asistencia-menu-arbol/models/node-type';
import { NodoArbolMenu } from 'src/app/asistente-en-linea/components/asistencia-menu-arbol/models/nodo-arbol-menu';
import { MenuArbolService } from 'src/app/asistente-en-linea/components/asistencia-menu-arbol/services/menu-arbol.service';
import { EditingMode } from '../models/editingMode';
import { ConfigService } from './config.service';


function sanitizeNode(node: any) {
  node.childs = Array.isArray(node.childs) ? node.childs : [];
  node.faqs = Array.isArray(node.faqs) ? node.faqs : [];
  node.childs.forEach(sanitizeNode);
}




@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.scss']
})
export class ConfigComponent implements OnInit {

  cargandoDatos: boolean;
  arbolMenu: ArbolMenu;
  currentFAQ: NodoArbolMenu[];
  faq: any;
  currentFather: NodoArbolMenu; //o currentRoute (la ruta hasta el nodo padre)
  displayedNodes: NodoArbolMenu[]; //Los nodos que se mostrarán en en menú en el estado actual del programa.
  cantidadNodos: number;
  numberOfSiblingsArr: number[];
  numberOfSiblingsArrCreation: number[];
  nodeBeforeReload: NodoArbolMenu;
  answerDisplayed: boolean;
  habilitado: boolean;
  answerNode: NodoArbolMenu;
  idMenu: string;
  codigoAsistente: string;
  nombreAsistente: string;
  visiblePath: string;
  maxPathLength: number = 100;
  faqsGlobal: any;

  // Indica el modo de edicion ; si es OFF entonces el panel derecho queda sin informacion
  editingMode: EditingMode;

  constructor(private configService: ConfigService, private route: ActivatedRoute, private router: Router) {
    this.answerDisplayed = false;
    this.idMenu = "1";
    this.editingMode = EditingMode.Off;
    this.cantidadNodos = 0;
  }



  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.idMenu = params.get('idMenu');
      this.codigoAsistente = params.get('codigoAsistente');
      this.nombreAsistente = params.get('nombreAsistente');

      this.loadArbolMenu(this.idMenu);
    });


  }

  irPaginaInicio() {
    this.router.navigate(['/config/home/']);
  }


  loadArbolMenu(idMenu) {
    this.cargandoDatos = true;
    this.configService.loadConfiglTree(idMenu, "-1").subscribe((data: any) => {
      //debugger
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        let jsonTree = data.content;

        console.log("JSON del backend:", JSON.parse(JSON.stringify(jsonTree)));
console.log("FAQs:", jsonTree.faqs);

        sanitizeNode(jsonTree);
        

        let root = new NodoArbolMenu("ROOT", idMenu, "Raiz", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 0, jsonTree.faqs)
        let arbol = new ArbolMenu(root);
        this.habilitado = jsonTree.habilitado;
        this.arbolMenu = arbol.buildTree(jsonTree)
        this.currentFather = this.arbolMenu.root;
        this.reloadTree();
        if (!this.codigoAsistente) {
          this.codigoAsistente = jsonTree.descripcionMenu;
        }

        this.faqsGlobal = jsonTree.faqs || [];
        this.loadFAQ();
        this.updateVisiblePath()
        if (this.nodeBeforeReload && this.nodeBeforeReload.id) {
          this.navigateToNode(this.nodeBeforeReload.id);
        }
        this.cargandoDatos = false;
      }
      else {
        alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    },
      error => {
        alert(error);
        this.cargandoDatos = false;
      })
  }

  returnToStart() {
    this.currentFather = this.arbolMenu.root;
    this.editingMode = EditingMode.Off
    this.reloadTree();
    this.clearAnswerDisplayed()
    this.loadFAQ()
    this.updateVisiblePath()
  }

  editingModeEmitterHandler(event) {
    this.editingMode = event;
  }


  seleccionarNodo(event) {
    for (let nodo of this.displayedNodes) {
      if (nodo.id == event) {
        if ((nodo.childs && nodo.childs.length > 0) || nodo.type==='TRAMITE')  {
          this.currentFather = nodo;
          this.reloadTree();
          this.editingMode = EditingMode.Off;
          this.loadFAQ()       
          this.updateVisiblePath()
        }
      }
    }
  }

  reloadTree() {
    if (this.currentFather) {
      this.displayedNodes = this.sortNodes(this.currentFather.childs);
    }
    this.cantidadNodos = this.displayedNodes.length;
    this.numberOfSiblingsArr = Array.from({ length: this.displayedNodes.length }, (_, i) => i + 1);
    this.numberOfSiblingsArrCreation = Array.from({ length: this.displayedNodes.length + 1 }, (_, i) => i + 1);
  }


  loadFAQ() {
    this.currentFAQ = []
    for (let faq of this.currentFather.faqs) {
      console.log(faq)
      let node = new NodoArbolMenu(
        faq.id,
        undefined,
        faq.consulta,
        faq.consulta,
        NodeType.FAQ,
        undefined,
        undefined,
        faq.respuesta,
        faq.idContenido,
        undefined,
        undefined,
        undefined
      );
      this.currentFAQ.push(node);
    }
  }

  addNode() {
    let path = this.currentFather.id === "ROOT" ? "Inicio" : `${this.currentFather.path}`;
    let node = new NodoArbolMenu("-1", this.idMenu, "Seleccione un nombre", undefined, NodeType.Question, this.currentFather.id, undefined, undefined, undefined, undefined, path, "1");
    this.configService.updateEditingData({ node: node, mode: EditingMode.Create, cantidadNodos: this.cantidadNodos, numberOfSiblingsArr: this.numberOfSiblingsArr, numberOfSiblingsArrCreation: this.numberOfSiblingsArrCreation, faqsGlobal: this.faqsGlobal })
    this.nodeBeforeReload = this.currentFather;
  }

  addFAQNode() {
    let node = new NodoArbolMenu("-1", this.idMenu, "Seleccione un nombre", undefined, NodeType.FAQ, this.currentFather.id, undefined, undefined, undefined, undefined, undefined, undefined)
    this.configService.updateEditingData({ node: node, mode: EditingMode.Create, cantidadNodos: this.cantidadNodos, numberOfSiblingsArr: this.numberOfSiblingsArr, numberOfSiblingsArrCreation: this.numberOfSiblingsArrCreation, faqsGlobal: this.faqsGlobal })
    this.nodeBeforeReload = this.currentFather;
    this.reloadTree();
  }

  navigateToNode(nodeId) {
    this.currentFather = this.arbolMenu.search(nodeId);
    this.reloadTree();
    this.loadFAQ()
    this.updateVisiblePath()
  }

  setNodeBeforeReload(parentId) {
    this.nodeBeforeReload = this.arbolMenu.search(parentId);
  }

  displayAnswer(obj) {
    this.answerNode = obj;
    this.answerDisplayed = true;
  }

  clearAnswerDisplayed() {
    this.answerNode = undefined;
    this.answerDisplayed = false;
  }

  loadParent() {
    this.currentFather = this.arbolMenu.search(this.currentFather.parentId);
    this.reloadTree();
    this.clearAnswerDisplayed()
    this.loadFAQ()
    this.updateVisiblePath()
  }

  sortNodes(nodes: NodoArbolMenu[]) {
    let sorted = nodes ? nodes.sort((a, b) => {
      return a.order - b.order;
    }) : [];
    return sorted;
  }

  //Slicing del path para que no quede muy largo
  updateVisiblePath() {
    if (this.currentFather.id === "ROOT") {
      return;
    }
    if (this.currentFather.path.length > this.maxPathLength) {
      let split = this.currentFather.path.split(">")
      let i = split.length - 1;
      let aux = "";
      while (i > 0) {
        if (aux.length + split[i].length > this.maxPathLength) {
          break;
        }
        if (i !== split.length - 1) {
          aux = split[i] + ">" + aux;
        }
        else { aux = split[i] }
        i--;
      }
      aux = aux === "" ? split[i] : aux;
      this.visiblePath = "... " + aux;
    }
    else {
      this.visiblePath = this.currentFather.path;
    }

  }
}